import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { DefaultComponent } from "./layout/default/default.component";
import { LoadDocumentsComponent } from "./components/load-documents/load-documents.component";
import { MsalGuard } from "@azure/msal-angular";
import { DocumentsComponent } from "./components/documents/documents.component";
import { TestServicesComponent } from "./components/test-services/test-services.component";
import { ParameterComponent } from "./components/parameter/parameter.component";
import { UserComponent } from "./components/user/user.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { AutorizacionComponent } from "./components/autorizacion/autorizacion.component";

const routechild: Routes = [
  { path: "home", component: HomeComponent },
  { path: "User",component: UserComponent},
  { path: "load-documents", component: LoadDocumentsComponent },
  { path: "documents", component: DocumentsComponent },
  { path: "test-service", component: TestServicesComponent },
  { path: "Parameter", component: ParameterComponent },
  { path: "Profile", component: ProfileComponent },
  { path: "autorizacion", component: AutorizacionComponent }
];

const routes: Routes = [
  {
    path: "error",
    component: DefaultComponent,
    children: routechild,
  },
  {
    path: "code",
    component: DefaultComponent,
    children: routechild,
  },
  {
    path: "state",
    component: DefaultComponent,
    children: routechild,
  },
  {
    path: "",
    component: DefaultComponent,
    children: routechild,
  },
  {
    path: "id_token",
    component: DefaultComponent,
    children: routechild,
  },
];
const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // Don't perform initial navigation in iframes
      initialNavigation: !isIframe ? "enabled" : "disabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
